export default `
clip-path: polygon(0% 0%, 100% 0%, 100% 85%, 50% 85%, 25% 100%, 25% 85%, 0% 85%);
`
